import React from 'react';
import ProfileCard from './ProfileCard';
import { ProfileData } from '@/types/profile';
import { SortOption } from '@/utils/profileUtils';

interface ProfileGridProps {
  profiles: ProfileData[];
  onLike: (profileId: string) => void;
  onViewProfile: (username: string) => void;
  getConnectionStatus: (profileId: string) => 'none' | 'sent' | 'received' | 'matched';
  canLike?: boolean;
  sortBy: SortOption;
}
export const ProfileGrid: React.FC<ProfileGridProps> = ({
  profiles,
  onLike,
  onViewProfile,
  getConnectionStatus,
  canLike = true,
  sortBy
}) => {
  if (profiles.length === 0) {
    return <div className="text-center py-12">
        <p className="text-white/60 text-lg mb-4">
          Nenhum perfil encontrado
        </p>
        <p className="text-white/40 text-sm">
          Tente ajustar seus filtros ou volte mais tarde
        </p>
      </div>;
  }
  return <div className="grid gap-4 md:gap-6 grid-cols-2 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 auto-rows-fr mt-2 sm:mt-3 mb-4" style={{ contain: 'layout style', willChange: 'contents' }}>
      {profiles.map(profile => <div key={profile.id || profile.username} className="w-full py-0" style={{ contain: 'layout' }}>
          <ProfileCard profile={profile} onLike={() => onLike(profile.id)} connectionStatus={getConnectionStatus(profile.id)} canLike={canLike} sortBy={sortBy} />
        </div>)}
    </div>;
};
export default ProfileGrid;